import React from "react";
import { Link } from "react-router-dom";
import { RobotIcon } from "@phosphor-icons/react";

export const PublicLayout = ({ children, title, subtitle, eyebrow }) => {
  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="border-b border-zinc-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-sm bg-amber-500 text-zinc-950">
              <RobotIcon size={20} weight="fill" />
            </div>
            <div>
              <p className="font-display text-base font-black uppercase tracking-tight text-zinc-950">
                Megatron
              </p>
              <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-zinc-500">
                IG Automation
              </p>
            </div>
          </Link>
          <nav className="flex gap-4 text-xs font-semibold text-zinc-600">
            <Link to="/privacy" className="hover:text-amber-600">
              Privacy
            </Link>
            <Link to="/data-deletion" className="hover:text-amber-600">
              Data Deletion
            </Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12 md:py-20">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-600">
          {eyebrow}
        </p>
        <h1
          className="mt-2 font-display text-4xl font-black tracking-tighter text-zinc-950 sm:text-5xl"
          data-testid="public-page-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl text-base text-zinc-500">{subtitle}</p>
        )}
        <div className="prose prose-zinc mt-10 max-w-none">{children}</div>
      </main>

      <footer className="border-t border-zinc-200 bg-white">
        <div className="mx-auto flex max-w-3xl flex-col items-start justify-between gap-2 px-6 py-6 sm:flex-row sm:items-center">
          <p className="text-xs text-zinc-500">
            &copy; {new Date().getFullYear()} Megatron — Instagram Comment-to-DM Automation
          </p>
          <p className="text-xs text-zinc-400">
            Independent tool, not affiliated with Meta or Instagram.
          </p>
        </div>
      </footer>
    </div>
  );
};
